export var appColors = {
    color: {
        taupe1: '#E8E8DC',
        taupe2: '#F5F5F0',
        navy2: '#063D8F',
        darkBlue: '#063D8F',
        blue1: '#367FFF',
        blue2: '#7da9f1',
        blue3: '#B6D1FF',
        blue4: '#E8EEF9',
        blue5: '#DFF1FF',
        blue6: '#ECF3FF',
        blue7: '#eef4ff',
        blue8: '#D5E4FF',
        blue9: '#DEEAFF',
        blue10: '#ecf6ff',
        navy3: '#03295F',
        red1: '#FF0000',
        red2: '#b01111',
        orange1: '#FF5B2B',
    },
    neutral: {
        transparent: 'transparent',
        white: '#FFFFFF',
        black: '#000000',
        lightGray: '#C3C3B9',
        mediumGray: '#F4F4EE',
        gray1: '#696969',
        gray2: '#fbfcff',
        gray3: '#f5f5f5',
        gray4: '#C4C4C4',
        charcoal: '#2D2D2D',
    },
};
